export enum MapName {
  main = 'main'
}
